"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CouponList = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var coupon_1 = require("../../model/coupon");
var service_1 = require("../../../library/base/service");
var CouponList = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(CouponList, _super);
    function CouponList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '618优惠券列表';
        _this.code = '300201';
        _this.desc = '618优惠券列表';
        _this.requestParams = new coupon_1.CouponListRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return CouponList;
}(service_1.BaseService));
exports.CouponList = CouponList;
//# sourceMappingURL=couponList.js.map